"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navbarEntries = void 0;
var _utils = require("./utils");
var _constants = require("./constants");
/* EXAMPLE C1-NAVBAR USAGE */
// navbar = navbar.getNavItemsForUser({
//    user: 'complete authenticateUser object from c1',
//    enableWfm: 'launch darkly feature flag goes here'
//    forgerockIdToken: 'forgerock user token goes here',
//  })
// Items that are displayed as sub-items of root NavbarItems
const submenuItems = {
  AgentPerformance: {
    key: "AgentPerformance",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.AGENT_PERFORMANCE, false, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.AGENT_PERFORMANCE)
  },
  TeamPerformance: {
    key: "TeamPerformance",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.TEAM_PERFORMANCE, false, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.TEAM_PERFORMANCE)
  },
  OrganizationPerformance: {
    key: "OrganizationPerformance",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.ORGANIZATION_PERFORMANCE, false, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.ORGANIZATION_PERFORMANCE)
  },
  MetricAdministration: {
    key: "MetricAdministration",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.METRIC_ADMINISTRATION, false, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.METRIC_ADMINISTRATION)
  },
  transcriptionSearch: {
    key: "transcriptionSearchTitle",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.TRANSCRIPTION_SEARCH, true, args.withinC1),
    isAllowed: args => !!args.transcriptionSearch && (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.TRANSCRIPTION_SEARCH)
  },
  analyticsDashboard: {
    key: "analyticsDashboardTitle",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.ANALYTICS_DASHBOARD, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.ANALYTICS_DASHBOARD)
  },
  myAvailability: {
    key: "myAvailabilityTitle",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.MY_AVAILABILITY, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.VIEW_SCHEDULES)
  },
  mySchedule: {
    key: "mySchedule",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.MY_SCHEDULE, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.VIEW_SCHEDULES)
  },
  agentSchedules: {
    key: "agentSchedules",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.AGENT_SCHEDULES, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.EDIT_SCHEDULES)
  },
  planning: {
    key: "planning",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.PLANNING, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.PLAN_SCHEDULES)
  },
  ids: {
    key: "intradayDynamicSchedulingTitle",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.INTRADAY_SCHEDULING, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.PLAN_SCHEDULES)
  },
  schedChangeMgmt: {
    key: "scheduleEditManagementTitle",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.SCHEDULE_MANAGEMENT, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.SCHEDULE_CHANGE_MANAGEMENT)
  },
  assetBrowser: {
    key: "reports",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.AR_ASSET_BROWSER, false, args.withinC1),
    isAllowed: args => !!args.dataLibrary && (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.ASSET_BROWSER)
  },
  dataLibrary: {
    key: "dataLibrary",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.AR_DATA_LIBRARY, false, args.withinC1),
    isAllowed: args => !!args.dataLibrary && (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.VIEW_CDM_DATA_LIBRARY)
  },
  settings: {
    key: "settings",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.CDM_SETTINGS, false, args.withinC1),
    isAllowed: args => !!args.settings && (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.CDM_SETTINGS)
  },
  trendingTopics: {
    key: "trendingTopics",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.TRENDING_TOPICS, false, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.TRENDING_TOPICS)
  },
  autoQA: {
    key: "autoQA",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.AUTO_QA, false, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.AUTO_QA)
  },
  smartTags: {
    key: "smartTags",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.SMART_TAGS, false, args.withinC1),
    isAllowed: args => !!args.enableSmartTags && (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.SMART_TAGS)
  }
};
const navbarEntries = exports.navbarEntries = {
  dashboard: {
    key: "dashboard",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.DASHBOARD, false, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.DASHBOARD)
  },
  recordings: {
    key: "recordings",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.RECORDINGS, false, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.RECORDINGS)
  },
  recordingControls: {
    key: "recordingControls",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.RECORDING_CONTROLS, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.RECORDING_CONTROLS)
  },
  contactQueue: {
    key: "contactQueue",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.CONTACT_QUEUE, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.CONTACT_QUEUE)
  },
  performanceCoaching: {
    key: "performanceCoaching",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.PERFORMANCE_COACHING, false, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.PERFORMANCE_COACHING),
    children: [submenuItems.AgentPerformance, submenuItems.TeamPerformance, submenuItems.OrganizationPerformance, submenuItems.MetricAdministration]
  },
  performanceManagement: {
    key: "performanceManagement",
    url: args => (0, _utils.buildTenantSubdomainUrl)(args.user?.subdomainUrl, _constants.ROUTE_PATHS.PERFORMANCE_MANAGEMENT),
    isAllowed: args => args.user?.authenticationMethod === _constants.AUTH_METHODS.FORGEROCK && !!args.user?.subdomainUrl && args.user?.subdomainUrl.trim() !== '' && (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.PERFORMANCE_MANAGEMENT)
  },
  legacyWfm: {
    key: "schedulesAndPlanning",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.SCHEDULE, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.VIEW_SCHEDULES),
    children: [submenuItems.myAvailability, submenuItems.mySchedule, submenuItems.agentSchedules, submenuItems.planning, submenuItems.ids, submenuItems.schedChangeMgmt]
  },
  wfm: {
    key: "wfm",
    url: args => args.wfmConfig?.wfmBaseUrl + '/web/WFM/#/',
    isAllowed: args => !!args.enableWfm && !!args.wfmConfig?.navItems && args.user?.authenticationMethod === _constants.AUTH_METHODS.FORGEROCK && args.user?.tenantId !== -1 &&
    // TODO: replace once sysadmin permissions exist on the backend server
    (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.WFM),
    children: args => args.wfmConfig?.wfmBaseUrl ? (0, _utils.convertWfmItemsToC1Format)(args.wfmConfig.navItems, args.wfmConfig.wfmBaseUrl) : []
  },
  messaging: {
    key: "messaging",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.MESSAGING, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.MESSAGING)
  },
  analytics: {
    key: "analytics",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.ANALYTICS, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.ANALYTICS),
    children: [submenuItems.transcriptionSearch, submenuItems.analyticsDashboard, submenuItems.trendingTopics, submenuItems.autoQA, submenuItems.smartTags]
  },
  botAnalytics: {
    key: "botAnalytics",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.BOT_ANALYTICS, false, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.BOT_ANALYTICS)
  },
  agentExplorer: {
    key: "agentExplorer",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.AGENT_EXPLORER, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.AGENT_EXPLORER)
  },
  reporting: {
    key: "reporting",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.REPORTS, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.REPORTS)
  },
  dataExplorer: {
    key: "dataExplorer",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.DATA_EXPLORER, false, args.withinC1),
    isAllowed: args => !!args.legacyBI && (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.ASSET_BROWSER),
    children: [submenuItems.assetBrowser, submenuItems.dataLibrary, submenuItems.settings]
  },
  biInsights: {
    key: "biInsights",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.INSIGHTS, false, args.withinC1),
    isAllowed: args => !!args.insights && (args.showInsightsWithDXPermissions && (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.ASSET_BROWSER) || (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.BI_INSIGHTS))
  },
  addOns: {
    key: "addOns",
    url: args => args.innovationCenterUrl + "?idtoken=" + args.forgerockIdToken,
    isAllowed: args => !!args.innovationCenterUrl,
    external: true
  },
  appManagement: {
    key: "applicationMgmt",
    url: args => (0, _utils.buildC1Url)(args.c1BaseUrl, _constants.ROUTE_PATHS.APPLICATION_MANAGEMENT, true, args.withinC1),
    isAllowed: args => (0, _utils.hasAnyPermissions)(args.user?.permissions ?? [], _constants.PAGE_PERMISSIONS.APPLICATION_MANAGEMENT)
  }
};
//# sourceMappingURL=navbar.js.map